import { __require as requireCommon } from '../node_modules/.pnpm/highlight.js@11.11.1/node_modules/highlight.js/lib/common.js';

requireCommon();
//# sourceMappingURL=common.js.map
